import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/tailwind.css";
import "./assets/index.css";
import Mixins from "./utils/mixins";

Vue.config.productionTip = false;
Vue.mixin(Mixins);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
